import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Pest } from '../../_model/pest-response/pest';
import { PestResponse } from '../../_model/pest-response/pest-response';
import { TableResponse } from '../../_model/table-response/table-response';
import { Constants } from '../../_model/constants';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule  } from '@angular/material/card';
@Component({
  selector: 'app-pest-information-dialog',
  templateUrl: './pest-information-dialog.component.html',
  standalone: true,
  imports: [MatTableModule, MatDialogModule, MatInputModule, MatSelectModule, MatButtonModule, MatCardModule],
  styleUrls: ['./pest-information-dialog.component.scss']
})
export class PestInformationDialogComponent implements OnInit {

  public pestInformation!: TableResponse;
  public item: any;
  tableData!: TableResponse;
  tableDisplayedColumns!: string[];
  displayedColumns: string[] = ['pest_service', 'pest_name', 'pest_location'];
  constructor(public datepipe: DatePipe, public matDialogRef: MatDialogRef<PestInformationDialogComponent, Pest>,
    @Inject(MAT_DIALOG_DATA) public data: { pestInformation: TableResponse; trigger: ElementRef; item: any }) { }

  ngOnInit() {
    this.pestInformation = this.data.pestInformation;
    this.item = this.data.item;
     this.tableDisplayedColumns = this.pestInformation.data?.tableDefinitions?.map(
          (c) => c.columnDef
        ) || [];
    const rect = this.data.trigger.nativeElement.getBoundingClientRect();
  }

}